<template>
  <Row>
        <i-col span="12">
                  <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="100">
            <FormItem label="权限名称" prop="name">
                <i-input v-model="formValidate.name" placeholder="请输入权限名称"></i-input>
            </FormItem>
            <FormItem label="权限等级" prop="type">
              <Select v-model="formValidate.type" style="width:260px">
                <Option v-for="item in privilegetype" :value="item.type" :key="item.type">{{ item.value }}</Option>
             </Select>
            </FormItem>
            <FormItem label="权限描述" prop="description">
                <i-input v-model="formValidate.description" placeholder="请输入权限描述"></i-input>
            </FormItem>
                <FormItem label="菜单">
                <Select v-model="menu.lev1" style="width:100px" @on-change="changedata()">
                    
                    <Option v-for="item in menudata" :value="item.id" :key="item.id">{{ item.name }}</Option>
                </Select>
                <Select v-model="menu.lev2" style="width:100px" @on-change="changedatb" v-if="isshow">
                    <Option v-for="item in menudata[myindex].submenu" :value="item.id" :key="item.id">{{ item.name }}</Option>
                </Select>
                <Select v-model="menu.lev3" style="width:100px" @on-change="changedatc" v-if="isshow1">
                    <Option v-for="item in submenu" :value="item.id" :key="item.id">{{ item.name }}</Option>
                </Select>
                <Select v-model="menu.lev4" style="width:100px"  v-if="isshow2">
                    <Option v-for="item in mixsubmenu" :value="item.id" :key="item.id">{{ item.name }}</Option>
                </Select>
                 <Button type="primary" @click="menuinit()">重置</Button>  
             </FormItem>
             <FormItem label="权限按钮" prop="button_id" v-if="formValidate.type==1">
                    <i-input v-model="formValidate.button_id" placeholder="请输入权限按钮"></i-input>
             </FormItem>
              <FormItem label="控制器名" prop="control">
                    <i-input v-model="formValidate.control" placeholder="请输入控制器名"></i-input>
             </FormItem>
             <FormItem label="方法名" prop="action">
                    <i-input v-model="formValidate.action" placeholder="请输入方法名"></i-input>
             </FormItem> 
            <FormItem>
                <Button type="primary" @click="handleSubmit('formValidate')">提交</Button>
            </FormItem>
        </Form>
        </i-col>
    </Row>    
</template>
<script>
import { mapState } from "vuex";
import { company_createprivileges } from "../../api/privilegesapi";
import { company_menuindex } from "../../api/menuapi";
import constantdata from "../../constant/index";
export default {
  data() {
    const validatemenu_id = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请选择菜单"));
      } else {
        callback();
      }
    };
    const validatetype = (rule, value, callback) => {
      if (value === "" && this.isinit) {
        callback(new Error("请选择权限类型"));
      } else {
        callback();
      }
    };

    return {
      params: this.$route.params,
      privilegetype: constantdata.privilegetype,
      formValidate: {
        type: "",
        name: "",
        description: "",
        control: "",
        action: "",
        menu_id: "",
        button_id: ""
      },
      isinit: true,
      myindex: 0,
      isshow: false,
      isshow1: false,
      isshow2: false,
      submenu: [],
      mixsubmenu: [],
      menu: {
        lev1: "",
        lev2: ""
      },
      menudata: [
        {
          id: "0",
          name: "没数据"
        }
      ],
      ruleValidate: {
        name: [
          {
            required: true,
            message: "请输入权限名称",
            trigger: "blur"
          }
        ],
        menu_id: [{ validator: validatemenu_id, trigger: "blur" }],
        type: [
          {
            validator: validatetype,
            message: "请选择权限类型",
            trigger: "change"
          }
        ],

        button_id: [
          {
            required: true,
            message: "请输入权限按钮",
            trigger: "blur"
          }
        ]
      }
    };
  },
  props: {
    param: Object
  },
  // computed: mapState({
  //   menudata: state => state.menudata
  // }),
  methods: {
    handleSubmit(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.create();
        } else {
          this.$Message.error("Fail!");
        }
      });
    },
    create() {
      let para = this.formValidate;
      if (this.menu.lev1) {
        para.menu_id = this.menu.lev1;
        if (this.menu.lev2) {
          para.menu_id = this.menu.lev2;
          if (this.menu.lev3) {
            para.menu_id = this.menu.lev3;
            if (this.menu.lev4) {
              para.menu_id = this.menu.lev4;
            }
          }
        }
      }
      this.$Loading.start();
      company_createprivileges(para).then(res => {
        this.$Loading.finish();
        var data = res.data;
        if (data.code == 1) {
          this.$Message.success(data.message);
          this.isinit = false;
          this.init();
          this.menuinit();
        } else {
          this.$Message.error(data.message);
        }
      });
    },
    handleReset(name) {
      this.$refs[name].resetFields();
    },
    passwdCheck() {
      if (this.formValidate.password != "") {
        return true;
      } else {
        return false;
      }
    },
    // Dropdown(name) {
    //   this.formValidate.menu_id = name;
    // },
    getmenulist() {
      var par = {};
      company_menuindex(par).then(res => {
        var data = res.data;
        if (data.code == 1) {
          this.menudata = data.data;
        }
      });
    },
    changedata() {
      this.menudata.forEach((element, index) => {
        if (element.id == this.menu.lev1) {
          this.myindex = index;
          if (element.submenu && element.submenu.length > 0) {
            this.isshow = true;
          } else {
            this.isshow = false;
          }
        }
      });
    },
    changedatb(res) {
      var data = this.menudata[this.myindex].submenu;
      data.forEach((element, index) => {
        if (element.id == res) {
          if (element.submenu && element.submenu.length > 0) {
            this.isshow1 = true;
            this.submenu = element.submenu;
          } else {
            this.isshow1 = false;
          }
        }
      });
    },
    changedatc(res) {
      this.submenu.forEach((element, index) => {
        if ((element.id == this.menu.lev3)) {
          if (element.submenu && element.submenu.length > 0) {
            this.isshow2 = true;
            this.mixsubmenu = element.submenu;
          } else {
            this.isshow2 = false;
          }
        }
      });
    },

    menuinit() {
      this.formValidate.menu_id = null;
      this.isshow = false;
      this.isshow1 = false;
      this.menu.lev1 = null;
      this.menu.lev2 = null;
      this.menu.lev3 = null;
      this.menu.lev4 = null;
      this.isshow2 = false;
    },
    init() {
      this.formValidate = {
        type: "",
        name: "",
        description: "",
        control: "",
        action: "",
        menu_id: "",
        button_id: ""
      };
    }
  },
  mounted() {
    this.getmenulist();
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/privileges/companyadd.vue